<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title>
            <v-icon left>mdi-clipboard-text</v-icon>Users
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn text @click="formOpen = true">
              <v-icon>mdi-plus</v-icon>Add User
            </v-btn>
          </v-toolbar-items>
          <template v-slot:extension>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </template>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="users"
          :loading="loading"
          :options.sync="options"
          :server-items-length="totalCount"
        >
          <template #[`item.role`]="{item}">
            {{ getRoleLabel(item.role) }}
          </template>
          <template #[`item.action`]="props">
            <v-btn icon @click="editItem(props.item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
      <list-form
        :item="editedItem"
        :open="formOpen"
        v-on:add="addItem()"
        v-on:cancel="cancelItem()"
        v-on:update="updateItem()"
      ></list-form>
    </div>
  </div>
</template>
<script>
import ListForm from "./_form";
import _ from "lodash";
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    ListForm
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Id", value: "id", align: "left" },
        { text: "Username", value: "username", align: "left" },
        { text: "Email", value: "email" },
        { text: "Firstname", value: "firstname" },
        { text: "Lastname", value: "lastname" },
        { text: "Role", value: "role" },
        { text: "Action", value: "action" }
      ],
      options: { rowsPerPage: 20 },
      formOpen: false,
      editedItem: null,
      roles: [
        { value: 9, label: "Admin" },
        { value: 6, label: "Fitter" },
        { value: 3, label: "Builder" },
        { value: 2, label: "External Fitter" },
        { value: 1, label: "Shop Keeper" },
        { value: 0, label: "Client" }
      ]
    };
  },
  watch: {
    options: {
      handler: _.debounce(function() {
        this.fetchUser();
      }, 100)
    },
    search: {
      handler: _.debounce(function() {
        this.fetchUser();
      }, 100)
    }
  },
  computed: {
    ...mapGetters("users", ["users", "totalCount", "loading"]),
  },
  mounted: function() {
    this.fetchUser(); //method1 will execute at pageload
  },
  methods: {
    ...mapActions("users", {getUsers : 'index', deleteUser: 'delete'}),
    getRoleLabel(role){
      const r = this.roles.find(r => r.value == role)
      return r ? r.label : '-' 
    },
    fetchUser() {
      this.getUsers({
        pagination: this.options,
        search: this.search
      });
    },
    addItem() {
      this.formOpen = false;
      this.editedItem = null;
      this.fetchUser();
    },
    updateItem() {
      this.formOpen = false;
      this.editedItem = null;
      this.fetchUser();
    },
    cancelItem() {
      this.formOpen = false;
      this.editedItem = null;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.formOpen = true;
    },
    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") &&
        this.deleteUser({
            model: item
          })
          .then(() => {
            this.fetchUser();
          });
    },
    userRole: function(role) {
      return this.roles.find(r => r.value == role).label;
    }
  }
};
</script>
